import styled from 'styled-components';

const LoginWrapper = styled.div`
    height: 100vh;
    width: 100vw;
    background-color: #F9F9FA;
`;

export default LoginWrapper;